if (!customElements.get("m-testimonials")) {

  class MTestimonials extends HTMLElement {

    constructor() {
      super();
    }


    connectedCallback() {

      let containerType;
      let autoplay;


      if (this.dataset.design) {
        this.design = this.dataset.design;
      }


      if (this.dataset.container) {
        containerType = this.dataset.container;
      }


      if (this.dataset.autoplay) {
        autoplay = this.dataset.autoplay === "true";
      }


      this.container = this.closest(".m-testimonials");


      if (!this.design) {

        return console.warn(
          "Failed to init Testimonials: design not found!!"
        );

      }


      this.sliderContainer =
        this.querySelector(".swiper-container");


      if (!this.sliderContainer) {

        this.classList.add("opacity-100");

        return;

      }


      this.defaultSettings = {

        pagination: {
          el: this.container.querySelector(
            ".swiper-pagination"
          ),
          clickable: true
        },


        navigation: {

          nextEl:
            this.container.querySelector(
              ".m-slider-controls__button-next"
            ),

          prevEl:
            this.container.querySelector(
              ".m-slider-controls__button-prev"
            )

        },


        autoplay: autoplay
          ? {
              delay: 5000,
              pauseOnMouseEnter: false,
              disableOnInteraction: false
            }
          : false,


        loop: true,

        slidesPerView: 1

      };


      this.settings = {};


      let gutter = 400;



      switch (this.design) {


        /* =================================================
           LAYOUT 1
        ================================================= */

        case "testimonials-1":

          this.settings = {

            centeredSlides: true,

            slidesPerView: 1,

            slidesPerGroup: 1,

            spaceBetween: 20,

            speed: 300,

            slideToClickedSlide: true,

            loop: false,


            breakpoints: {

              768: {

                slidesPerView: 3,

                slidesPerGroup: 3,

                spaceBetween: 20,

                speed: 1000

              },


              1280: {

                slidesPerView: 5,

                slidesPerGroup: 3,

                spaceBetween: 30

              },


              2560: {

                slidesPerView: 7,

                slidesPerGroup: 3

              }

            }

          };

          break;



        /* =================================================
           LAYOUT 2
        ================================================= */

        case "testimonials-2":

          this.settings = {

            slidesPerView: 1,

            spaceBetween: 30,


            breakpoints: {

              768: {

                slidesPerView: 3,

                slidesPerGroup: 3

              }

            }

          };

          break;



        /* =================================================
           LAYOUT 3
        ================================================= */

        case "testimonials-3":

          this.settings = {

            slidesPerView: 1,

            spaceBetween: 30,


            breakpoints: {

              768: {

                slidesPerView:
                  containerType === "container-fluid"
                    ? 2
                    : 2

              },


              992: {

                slidesPerView:
                  containerType === "container-fluid"
                    ? 3
                    : 2

              }

            }

          };

          break;



        /* =================================================
           LAYOUT 4
        ================================================= */

        case "testimonials-4":


          if (containerType === "container-fluid") {

            gutter = 200;

          }


          if (containerType === "container") {

            gutter = 150;

          }


          this.settings = {

            slidesPerView: 1,

            centeredSlides: true,

            slideToClickedSlide: true,


            breakpoints: {

              768: {

                spaceBetween:
                  parseInt(gutter / 4),

                slidesPerView: 3

              },


              992: {

                spaceBetween:
                  gutter / 2,

                slidesPerView: 3

              },


              1920: {

                spaceBetween: gutter,

                slidesPerView: 3

              }

            }

          };

          break;



        /* =================================================
           LAYOUT 6
           PHOTO REVIEW DESIGN
        ================================================= */

        case "testimonials-6":

          this.settings = {

            slidesPerView: 1.08,

            slidesPerGroup: 1,

            spaceBetween: 12,

            speed: 650,

            loop: true,

            grabCursor: true,

            watchOverflow: true,

            observer: true,

            observeParents: true,

            resizeObserver: true,


            pagination:
              this.dataset.paginationType == "fraction"

                ? {

                    el:
                      this.container.querySelector(
                        ".swiper-pagination"
                      ),

                    clickable: true,

                    type: "fraction"

                  }

                : {

                    el:
                      this.container.querySelector(
                        ".swiper-pagination"
                      ),

                    clickable: true

                  },


            breakpoints: {


              480: {

                slidesPerView: 1.25,

                spaceBetween: 14

              },


              640: {

                slidesPerView: 1.7,

                spaceBetween: 16

              },


              768: {

                slidesPerView: 2,

                slidesPerGroup: 1,

                spaceBetween: 18

              },


              990: {

                slidesPerView: 3,

                slidesPerGroup: 1,

                spaceBetween: 20

              },


              1280: {

                slidesPerView: 4,

                slidesPerGroup: 1,

                spaceBetween: 20

              },


              1600: {

                slidesPerView: 4,

                slidesPerGroup: 1,

                spaceBetween: 22

              }

            }

          };

          break;



        /* =================================================
           LAYOUT 7
        ================================================= */

        case "testimonials-7":

          this.settings = {

            slidesPerView: 2,

            spaceBetween: 16,

            loop: true,


            pagination:
              this.dataset.paginationType == "fraction"

                ? {

                    el:
                      this.container.querySelector(
                        ".swiper-pagination"
                      ),

                    clickable: true,

                    type: "fraction"

                  }

                : {

                    el:
                      this.container.querySelector(
                        ".swiper-pagination"
                      ),

                    clickable: true

                  }

          };

          break;



        /* =================================================
           LAYOUT 8
        ================================================= */

        case "testimonials-8":

          this.settings = {

            fade: {

              crossFade: true

            },


            pagination:
              this.dataset.paginationType == "fraction"

                ? {

                    el:
                      this.container.querySelector(
                        ".swiper-pagination"
                      ),

                    clickable: true,

                    type: "fraction"

                  }

                : {

                    el:
                      this.container.querySelector(
                        ".swiper-pagination"
                      ),

                    clickable: true

                  }

          };

          break;



        /* =================================================
           LAYOUT 5
        ================================================= */

        case "testimonials-5":

          this.settings = {

            fade: {

              crossFade: true

            }

          };

          break;

      }



      const images =
        this.querySelector(".m-tabs");


      if (images) {

        const interval = setInterval(() => {

          if (MinimogTheme.Tabs) {

            clearInterval(interval);

            this.imagesTab =
              new MinimogTheme.Tabs(images);

          }

        }, 50);

      }
      this.initSlider();
    }
    initSlider() {
      this.slider =
        new MinimogLibs.Swiper(
          this.sliderContainer,
          {
            ...this.defaultSettings,
            ...this.settings,
            on: {
              init: () => {
                setTimeout(() => {
                  window.dispatchEvent(
                    new Event("resize")
                  );
                }, 100);
              }
            }
          }
        );
      if (this.design === "testimonials-4") {
        this.slider.on(
          "activeIndexChange",
          (swiper) => {
            const {
              realIndex
            } = swiper;
            const indexElement =
              this.querySelector(
                ".m-testimonial-index"
              );
            if (indexElement) {
              indexElement.innerHTML = parseInt(realIndex) + 1;
            }
          }
        );
      }
      if (
        this.design === "testimonials-5" ||
        this.design === "testimonials-8"
      ) {
        this.slider.on(
          "slideChange",
          (swiper) => {
            const {
              realIndex
            } = swiper;
            if (this.imagesTab) {
              this.imagesTab.setActiveTab(
                realIndex
              );
            }
          }
        );
      }
      document.addEventListener(
        "shopify:block:select",
        (e) =>
          this.onBlockSelect(e)
      );
    }
    onBlockSelect(ev) {
      const block =
        ev.target;
      const index =
        Number(
          block.dataset.index
        );
      if (!this.slider) {
        return;
      }
      if (
        this.slider.params.loop &&
        typeof this.slider.slideToLoop ===
          "function"
      ) {
        this.slider.slideToLoop(index);
      } else {
        this.slider.slideTo(index);
      }
    }
  }
  customElements.define(
    "m-testimonials",
    MTestimonials
  );

}